module.exports = __webpack_public_path__ + "static/media/closing-modal-editor-right.14d97a0e.jpg";